import { render, staticRenderFns } from "./MediaSidebar.vue?vue&type=template&id=684cffff&scoped=true&"
import script from "./MediaSidebar.vue?vue&type=script&lang=js&"
export * from "./MediaSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MediaSidebar.vue?vue&type=style&index=0&id=684cffff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684cffff",
  null
  
)

export default component.exports